import './App.css';
import Login from './Login';
import Home from './Home';
import Users from './Users';
import UserDetails from './UserDetails';
import Webhooks from './Webhooks';
import Businesses from './Businesses';
import Business from './Business';
import Embedded from './Embedded';
import Hosted from './Hosted';
import verifyAccess from './VerifyAccess';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import {
  createBrowserRouter,
  RouterProvider, 
  Link, 
  BrowserRouter,
  useNavigate
} from "react-router-dom";

import React, { useEffect, useState } from "react";
import logo from './HOESJ.png';
import ErrorPage from "./ErrorPage";
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import AirlineStopsRoundedIcon from "@mui/icons-material/AirlineStopsRounded";
import LocalPostOfficeRoundedIcon from '@mui/icons-material/LocalPostOfficeRounded';
import MarginRoundedIcon from '@mui/icons-material/MarginRounded';
import SettingsApplicationsRoundedIcon from "@mui/icons-material/SettingsApplicationsRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import PlumbingRoundedIcon from "@mui/icons-material/PlumbingRounded";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";

interface User {
  email?: string;
  token?: string;
}

function App() {
  const [loggedIn, setLoggedIn] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const [business, setBusiness] = useState<string>("business_11W8HcBHkTW1TeQg"); // Loading state
  const user: User = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!) : {};
  //const baseUrl: string = "https://m191ddm1be.execute-api.eu-central-1.amazonaws.com/dev/";
  const baseUrl: string = "https://api.hoesj.nl/";
  //const baseUrl: string = "http://localhost:3080/dev/";



  useEffect(() => {
    document.title = "Hoesj"

    if (!user || !user.token) {
      setLoggedIn(false);
      return;
    }

    async function checkAccess(token: string) {
      const { message } = await verifyAccess(token, baseUrl, undefined, undefined);
      const hasAccess = message === "success";
      console.log("Access:", hasAccess);
      setLoggedIn(message === 'success');
      setEmail(user.email || '');
      console.log("Logged in");
    }

    checkAccess(user.token!);
  }, [user]);

  const router = createBrowserRouter([
    {
      id: "home",
      path: "/",
      element: <Home email={email} loggedIn={loggedIn} setLoggedIn={setLoggedIn} />,
      errorElement: <ErrorPage />,
    },
    {
      id: "login",
      path: "/login",
      element: <Login setLoggedIn={setLoggedIn} setEmail={setEmail} baseUrl={baseUrl} />,
      errorElement: <ErrorPage />,
    },
    {
      id: "users",
      path: "/users",
      element: <Users email={email} loggedIn={loggedIn} token={user.token || ''} setLoggedIn={setLoggedIn} setEmail={setEmail} baseUrl={baseUrl} />,
      errorElement: <ErrorPage />,
    },
    {
      id: "embedded",
      path: "/embedded",
      element: <Embedded email={email} loggedIn={loggedIn} token={user.token || ''} setLoggedIn={setLoggedIn} setEmail={setEmail} baseUrl={baseUrl} business={business} setBusiness={setBusiness}/>,
      errorElement: <ErrorPage />,
    },
    {
      id: "hosted",
      path: "/hosted",
      element: <Hosted email={email} loggedIn={loggedIn} token={user.token || ''} setLoggedIn={setLoggedIn} setEmail={setEmail} baseUrl={baseUrl} business={business} setBusiness={setBusiness}/>,
      errorElement: <ErrorPage />,
    },
    {
      id: "webhooks",
      path: "/webhooks",
      element: <Webhooks email={email} loggedIn={loggedIn} token={user.token || ''} setLoggedIn={setLoggedIn} setEmail={setEmail} baseUrl={baseUrl} />,
      errorElement: <ErrorPage />,
    }
  ]);

  const sideBarHidden: React.CSSProperties = loggedIn ? { display: 'block' } : { display: 'none' };
  const logoHidden: React.CSSProperties = loggedIn ? { display: 'none' } : { display: 'block' };
  

  return (
    <React.StrictMode>
          <BrowserRouter>    
    <div style={{ display: "flex", height: "100vh" }} className="container">
      {/* Sidebar on the left */}
      <div className="sideBar" style={sideBarHidden}>

        <Sidebar className="app">
          <Menu>
            <MenuItem>
            <img src={logo} className="App-logo-menu" alt="logo" />
            </MenuItem>
            <MenuItem icon={<GridViewRoundedIcon />} component={<Link to="/" />}> Home </MenuItem>
            <SubMenu label="Pipe" icon={<PlumbingRoundedIcon />}>
              <MenuItem icon={<LocalPostOfficeRoundedIcon />} component={<Link to="/webhooks" />}>
                Webhooks
              </MenuItem>
              <MenuItem icon={<MarginRoundedIcon />} component={<Link to="/embedded" />}>Embedded</MenuItem>
              <MenuItem icon={<AirlineStopsRoundedIcon />} component={<Link to="/hosted" />}>Hosted</MenuItem>
              <MenuItem icon={<BusinessRoundedIcon />} component={<Link to="/businesses" />}>Businesses</MenuItem>
            </SubMenu>
            <SubMenu label="Settings" icon={<SettingsApplicationsRoundedIcon />}>
              <MenuItem icon={<AccountCircleRoundedIcon />} component={<Link to="/users" />}> Users </MenuItem>
            </SubMenu>
            <LoginLogoutItem loggedIn={loggedIn} setLoggedIn={setLoggedIn} />

          </Menu>
        </Sidebar>
   
      </div>
  
      {/* Main content area */}
      <div className="mainContainer">
        {/* Centered logo */}
        <div style={logoHidden}>
        <div className="App-logo-div">
          <img src={logo} className="App-logo" alt="logo"/>
        </div>
        </div>
  
        {/* Non-centered content directly below the logo */}
        <Routes>
    <Route 
      path="/" 
      element={<Home email={email} loggedIn={loggedIn} setLoggedIn={setLoggedIn} />} 
      errorElement={<ErrorPage />} 
    />
    <Route 
      path="/login" 
      element={<Login setLoggedIn={setLoggedIn} setEmail={setEmail} baseUrl={baseUrl} />} 
      errorElement={<ErrorPage />} 
    />
    <Route 
      path="/users" 
      element={<Users email={email} loggedIn={loggedIn} token={user.token || ''} setLoggedIn={setLoggedIn} setEmail={setEmail} baseUrl={baseUrl} />} 
      errorElement={<ErrorPage />} 
    />
        <Route 
      path="/user" 
      element={<UserDetails email={email} loggedIn={loggedIn} token={user.token || ''} setLoggedIn={setLoggedIn} setEmail={setEmail} baseUrl={baseUrl} />} 
      errorElement={<ErrorPage />} 
    />
    <Route 
      path="/embedded" 
      element={<Embedded email={email} loggedIn={loggedIn} token={user.token || ''} setLoggedIn={setLoggedIn} setEmail={setEmail} baseUrl={baseUrl} business={business} setBusiness={setBusiness}/>} 
      errorElement={<ErrorPage />} 
    />
        <Route 
      path="/hosted" 
      element={<Hosted email={email} loggedIn={loggedIn} token={user.token || ''} setLoggedIn={setLoggedIn} setEmail={setEmail} baseUrl={baseUrl} business={business} setBusiness={setBusiness}/>} 
      errorElement={<ErrorPage />} 
    />
    <Route 
      path="/webhooks" 
      element={<Webhooks email={email} loggedIn={loggedIn} token={user.token || ''} setLoggedIn={setLoggedIn} setEmail={setEmail} baseUrl={baseUrl} />} 
      errorElement={<ErrorPage />} 
    />
        <Route 
      path="/businesses" 
      element={<Businesses email={email} loggedIn={loggedIn} token={user.token || ''} setLoggedIn={setLoggedIn} setEmail={setEmail} baseUrl={baseUrl} />} 
      errorElement={<ErrorPage />} 
    />
            <Route 
      path="/business" 
      element={<Business email={email} loggedIn={loggedIn} token={user.token || ''} setLoggedIn={setLoggedIn} setEmail={setEmail} baseUrl={baseUrl} />} 
      errorElement={<ErrorPage />} 
    />
  </Routes>
      
      </div>
    </div>
    </BrowserRouter>
  </React.StrictMode>
  
  
  );
}

// Separate component to handle Login/Logout with navigation
const LoginLogoutItem: React.FC<{ loggedIn: boolean, setLoggedIn: (loggedIn: boolean) => void }> = ({ loggedIn, setLoggedIn }) => {
  const navigate = useNavigate(); // useNavigate inside the component that is rendered in Router context

  const handleLoginLogout = () => {
    if (loggedIn) {
      localStorage.removeItem('user');
      setLoggedIn(false);
      navigate('/login'); // Navigate to login on logout
    } else {
      navigate('/login'); // Navigate to login page if not logged in
    }
  };

  return (
    <MenuItem 
      icon={<LogoutRoundedIcon />} 
      onClick={handleLoginLogout}
    >
      {loggedIn ? 'Logout' : 'Login'}
    </MenuItem>
  );
};

export default App;
